// 项目文件
const url = '/business/yhProjectFiles/'
// 项目文件类型
const urls = '/business/yhProjectFileTypes/'
const api = {
  selectYhProjectFilesCompilationByList: url + 'selectYhProjectFilesCompilationByList',
  insertYhProjectFiles: url + 'insertYhProjectFiles',
  deleteYhProjectFiles: url + 'deleteYhProjectFiles',
  selectYhProjectFilesByPage: url + 'selectYhProjectFilesByPage',
  insertYhProjectFileTypes: urls + 'insertYhProjectFileTypes',
  updateYhProjectFileTypes: urls + 'updateYhProjectFileTypes',
  deleteYhProjectFileTypes: urls + 'deleteYhProjectFileTypes',
  selectYhProjectFileTypesByList: urls + 'selectYhProjectFileTypesByList'
}
export default api
